import { Autocomplete, TextField } from '@mui/material';
import LoadingScreen from 'base/ui/components/LoadingScreen/loadingScreen';
import Pagination from 'base/ui/components/Pagination/pagination';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import { Fragment, SyntheticEvent, useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { AiFillCaretDown, AiOutlineDownload, AiOutlineMinus } from 'react-icons/ai';
import { FaSearch } from 'react-icons/fa';
import { TbLoaderQuarter } from 'react-icons/tb';
import { TiArrowUnsorted } from 'react-icons/ti';
import { CommonDate, ListDate } from 'services/commonDate_services';
import { BC08, ListKeynValue } from 'services/report_services';
import * as rootStore from 'stores/root_store';
import { PAGE_SIZE_DEFAULT } from 'utils/constants';
import CloseIcon from '@mui/icons-material/Close';
import ReactTooltip from 'react-tooltip';
import SearchCollapse from '../reportComponents/searchCollapse';
import { Button, DatePicker, Select } from 'antd';
import { formatNumber } from 'utils/formatHelper';
import CustomSelect from 'base/ui/components/CustomSelect';
import dayjs from 'dayjs';
import { ActionType, ProColumns } from '@ant-design/pro-components';
import TemplateReportModal from 'base/ui/components/Modal/TemplateReportModal';
import CustomProTable from 'base/ui/components/CustomTable';
import { useResizableColumns } from 'utils/reportHelper';
import SaveReportForm from '../reportComponents/reportForm';

const Style = {
  MuiTableCellRoot: {
    fontSize: '13px',
    fontWeight: 700,
    padding: '5px 10px',
    lineHeight: '20px',
    color: 'white',
  },
  '.MuiOutlinedInput-root': {
    padding: 0,
  },
  '.MuiOutlinedInput-input': {
    fontSize: '13px',
  },
  '.MuiOutlinedInput-notchedOutline': { borderRadius: 0 },
  '.css-13xfq8m-MuiTabPanel-root': {
    padding: '5px !important',
  },
  '.css-tqw3aj .css-13xfq8m-MuiTabPanel-root': {
    padding: 5,
  },
};
export function createProductionActivities() {
  return observer(() => {
    //loading page when reload
    const [isLoading, setIsLoading] = useState(false);
    const [isReady, setIsReady] = useState(false);
    // list date

    //=======================================================================
    //======================================================================= REGISTER VARIALBE ZONE
    //=======================================================================.

    const [dataSearch, setDataSearch] = useState({
      paging: {
        pageSize: PAGE_SIZE_DEFAULT,
        pageIndex: 1,
        orderBy: '',
        orderByDesc: '',
      },
      equipmentName: undefined as string[] | undefined,
      workShoId: undefined as string | undefined,
      fromTime: undefined as string | undefined,
      toTime: undefined as string | undefined,
    });
    // Form validation-----------------------------------
    const { register, handleSubmit } = useForm<String>();
    //lay picked date
    const [pickedDate, setpickedDate] = useState<string>('Today');

    // danh sach phan xuong
    const [listPhanXuong, setListPhanXuong] = useState<ListKeynValue[]>([]);
    //danh sach may moc
    const [listEquip, setListEquip] = useState<ListKeynValue[]>([]);
    // lay danh sach date tu API
    const [commonDate, setCommonDate] = useState<ListDate[]>([]);

    const [dataAPI, setDataAPI] = useState<BC08[]>([]);

    //=======================================================================
    //======================================================================= HANDLE ZONE
    //=======================================================================

    // lấy from date , to date theo key
    const getDateByKey = async (key: string) => {
      await rootStore.commonDatePresenter.getDataByCommonDate(rootStore.commonDateStore, key);
      if (rootStore.commonDateStore.commonDate) {
        setDataSearch({
          ...dataSearch,
          fromTime:
            rootStore.commonDateStore.commonDate.fromDate !== ''
              ? rootStore.commonDateStore.commonDate.fromDate
              : undefined,
          toTime:
            rootStore.commonDateStore.commonDate.toDate !== ''
              ? rootStore.commonDateStore.commonDate.toDate
              : undefined,
        });
      }
    };

    const getDataAPI = async (data = dataSearch) => {
      await rootStore.reportPresenter.getBC08(rootStore.reportStore, data);
      if (rootStore.reportStore.BC08Response.isSuccess) {
        setDataAPI(rootStore.reportStore.BC08Response.data);
        return rootStore.reportStore.BC08Response.data;
      }
      return [];
    };

    // handle search form
    const onSearch = async () => {
      setIsLoading(true);
      const search = { ...dataSearch, paging: { ...dataSearch.paging, pageIndex: 1 } };
      setDataSearch(search);
      await getDataAPI(search);
      setIsLoading(false);
    };

    const handleChangeListTime = async (value: any, option: ListKeynValue | ListKeynValue[], idKey: string) => {
      if (option && !Array.isArray(option)) {
        setpickedDate(option.key);
        await getDateByKey(option.key);
      } else {
        setpickedDate('');
        setDataSearch({ ...dataSearch, fromTime: undefined, toTime: undefined });
      }
    };

    // event change list phan xuong in search

    const [columns, setColumns] = useState<ProColumns<BC08>[]>([
      {
        title: 'STT',
        dataIndex: 'stt',
        width: 75,
        key: 'stt',
        fixed: 'left',
        className: '!rounded-none !py-1',
        onCell: () => ({ style: { textAlign: 'center' } }),
      },
      {
        title: 'Máy/chuyền thực hiện',
        dataIndex: 'equipName',
        width: 200,
        key: 'equipName',
        fixed: 'left',
        className: '!py-1',
        sorter: true,
      },
      {
        title: 'Ngày SX',
        dataIndex: 'productionDateStart',
        width: 100,
        key: 'ngaySX',
        onCell: () => ({ style: { textAlign: 'center' } }),
        className: '!py-1',
        valueType: 'dateTime',
        fieldProps: {
          format: 'DD/MM/YYYY',
        },
        sorter: true,
      },
      {
        title: 'TG bắt đầu',
        dataIndex: 'productionDateStart',
        width: 100,
        key: 'productionDateStart',
        onCell: () => ({ style: { textAlign: 'center' } }),
        className: '!py-1',
        valueType: 'dateTime',
        fieldProps: {
          format: 'HH:mm',
        },
      },
      {
        title: 'TG kết thúc',
        dataIndex: 'productionDateEnd',
        width: 100,
        key: 'productionDateEnd',
        onCell: () => ({ style: { textAlign: 'center' } }),
        className: '!py-1',
        valueType: 'dateTime',
        fieldProps: {
          format: 'HH:mm',
        },
      },
      {
        title: 'TG thực hiện (Giờ)',
        dataIndex: 'executionHour',
        width: 100,
        key: 'executionTime',
        onCell: () => ({ style: { textAlign: 'right' } }),
        className: '!py-1',
        render: (dom, entity) => (dom !== '-' ? formatNumber(Number(dom), 0) : '-'),
      },
      {
        title: 'TG thực hiện (Phút)',
        dataIndex: 'executionMin',
        width: 100,
        key: 'executionTime',
        onCell: () => ({ style: { textAlign: 'right' } }),
        className: '!py-1',
        render: (dom, entity) => (dom !== '-' ? formatNumber(Number(dom), 0) : '-'),
      },
      {
        title: 'CV thực hiện',
        dataIndex: 'job',
        width: 100,
        key: 'job',
        sorter: true,
        className: '!py-1',
      },
      // {
      //   title: 'Số thẻ treo',
      //   dataIndex: 'palletNumber',
      //   width: 100,
      //   key: 'palletNumber',
      //   className: '!py-1',
      // },
      {
        title: 'LSX',
        dataIndex: 'workOrderCode',
        width: 100,
        key: 'workOrderCode',
        className: '!py-1',
        sorter: true,
      },
      {
        title: 'Nhóm SP',
        dataIndex: 'productGroup',
        width: 100,
        key: 'productGroup',
        className: '!py-1',
        sorter: true,
      },
      {
        title: 'Nhóm SP chi tiết',
        dataIndex: 'productGroupDetail',
        width: 100,
        key: 'productGroupDetail',
        className: '!py-1',
        sorter: true,
      },
      {
        title: 'Mã SP',
        dataIndex: 'productCode',
        width: 100,
        key: 'productCode',
        className: '!py-1',
        sorter: true,
      },
      {
        title: 'Tên SP',
        dataIndex: 'productName',
        width: 250,
        key: 'productName',
        className: '!py-1',
      },
      // {
      //   title: 'SL ghi nhận',
      //   dataIndex: 'soLuongGhiNhan1',
      //   width: 100,
      //   key: 'soLuongGhiNhan1',
      //   render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : '-'),
      //   className: '!py-1',
      //   onCell: () => ({ style: { textAlign: 'right' } }),
      //   sorter: true,
      // },
      // {
      //   title: 'ĐVT công đoạn',
      //   dataIndex: 'dvT1',
      //   width: 100,
      //   key: 'dvT1',
      //   className: '!py-1',
      //   sorter: true,
      // },
      {
        title: 'SL ghi nhận (pcs)',
        dataIndex: 'soLuongGhiNhan2',
        width: 100,
        key: 'soLuongGhiNhan2',
        className: '!py-1',
        onCell: () => ({ style: { textAlign: 'right' } }),
        render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : '-'),
        sorter: true,
      },
      {
        title: 'ĐVT',
        dataIndex: 'dvT2',
        width: 100,
        key: 'dvT2',
        className: '!py-1',
      },
      {
        title: 'SL NV thực hiện',
        dataIndex: 'workerNumber',
        width: 100,
        key: 'workerNumber',
        className: '!py-1',
        onCell: () => ({ style: { textAlign: 'right' } }),
        render: (text, record) => (text !== '-' ? formatNumber(Number(text), 0) : '-'),
        sorter: true,
      },
      {
        title: 'NV thực hiện',
        dataIndex: 'staffs',
        width: 150,
        key: 'staffs',
        className: '!py-1 whitespace-pre-line',
        render(dom, entity, index, action, schema) {
          return entity.staffs ? entity.staffs.replace(/,/g, '\n') : '-';
        },
      },
      {
        title: 'Ghi chú',
        dataIndex: 'description',
        width: 100,
        key: 'description',
        className: '!py-1',
      },
    ]);

    //=======================================================================
    //======================================================================= USEFFECT ZONE
    //=======================================================================

    const getDateCommon = async () => {
      await rootStore.commonDatePresenter.getListCommonDate(rootStore.commonDateStore);
      if (rootStore.commonDateStore.listDate.data) setCommonDate(rootStore.commonDateStore.listDate.data);
    };
    const getListWSName = async () => {
      await rootStore.reportPresenter.getListWorkShop(rootStore.reportStore);
      if (rootStore.reportStore.listKeynValue.isSuccess) setListPhanXuong(rootStore.reportStore.listKeynValue.data);
    };
    const getListEquipCard = async () => {
      await rootStore.reportPresenter.getListEquipCard(rootStore.reportStore);
      if (rootStore.reportStore.listKeynValue.isSuccess) {
        setListEquip(rootStore.reportStore.listKeynValue.data);
      }
    };

    useEffect(() => {
      (async () => {
        await getDateByKey(pickedDate);
        setIsReady(true);
        getDateCommon();
        getListEquipCard();
        getListWSName();
      })();
    }, []);

    const handleResize =
      (index: number, id?: number) =>
        (e: any, { size }: any) => {
          setColumns((prevColumns) => {
            const nextColumns = [...prevColumns];
            nextColumns[index] = {
              ...nextColumns[index],
              width: size.width,
              // @ts-ignore
              children: nextColumns[index].children
                ? // @ts-ignore
                nextColumns[index].children.map((child, i) => {
                  if (id === i) {
                    return {
                      ...child,
                      width: size.width,
                    };
                  }
                  return child;
                })
                : undefined,
            };
            return nextColumns;
          });
        };

    const constDataName = 'bc-09';
    const tableRef = useRef<ActionType>();
    const {
      isResizablePresent,
      resizableColumnSelect,
      columnsState,
      handleColumnsStateChange,
      templateReportModalRef,
      userReports,
      selectedReportId,
      templateReportModalProps,
    } = useResizableColumns<BC08>(columns, setColumns, constDataName);

    //=======================================================================
    //======================================================================= RETURN ZONE
    //=======================================================================
    return isReady ? (
      <div className="w-full py-3 px-5">
        <SearchCollapse title="BC09. BÁO CÁO hoạt động sản xuất của máy móc/chuyền sản xuất">
          <form onSubmit={handleSubmit(onSearch)} className="w-full px-8  py-2 lg:grid lg:grid-cols-2 flex flex-col">
            {/* Chọn phan xuong */}
            <div className="w-full  mb-1 sm:items-center grid grid-cols-3">
              <CustomSelect
                title="Phân xưởng"
                data={listPhanXuong}
                fieldNames={{ label: 'value', value: 'key' }}
                filterOption={(input, option) => (option?.value ?? '').toLowerCase().includes(input.toLowerCase())}
                onChangeValue={(value, option) => {
                  if (option && !Array.isArray(option)) {
                    // setPhanXuong(option.key);
                    setDataSearch({ ...dataSearch, workShoId: option.key });
                  } else {
                    // setPhanXuong(null);
                    setDataSearch({ ...dataSearch, workShoId: undefined });
                  }
                }}
                idKey="phanXuong"
                showSearch
                allowClear
                placeholder="Chọn Phân Xưởng"
              />
            </div>

            {/* Chọn may moc / chuyen */}
            <div className="w-full  mb-1 sm:items-center grid grid-cols-3">
              <CustomSelect
                title="Máy móc/Chuyền"
                mode="multiple"
                data={listEquip}
                fieldNames={{ label: 'value', value: 'key' }}
                filterOption={(input, option) => (option?.value ?? '').toLowerCase().includes(input.toLowerCase())}
                onChangeValue={(value, option) => {
                  if (option && Array.isArray(option)) {
                    // setEquip(
                    // option.map((val) => {
                    //   return val.key;
                    // }),
                    // );
                    setDataSearch({
                      ...dataSearch,
                      equipmentName: option.map((val) => {
                        return val.key;
                      }),
                    });
                  } else {
                    setDataSearch({
                      ...dataSearch,
                      equipmentName: undefined,
                    });
                  }
                }}
                idKey="mayChuyen"
                showSearch
                allowClear
                placeholder="Chọn máy/chuyền..."
              />
            </div>

            {/* Chọn thoi gian */}
            <div className="w-full  mb-1 sm:items-center grid grid-cols-3">
              <CustomSelect
                title="Ngày sản xuất"
                data={commonDate}
                value={commonDate.find((date) => date.key === pickedDate)}
                onChangeValue={handleChangeListTime}
                idKey="pickedDate"
                showSearch
                allowClear
                placeholder="Chọn khoảng thời gian"
              />
            </div>
            <div></div>

            {/* từ ngày */}
            <div className="w-full sm:flex-row  mb-1 sm:items-center grid grid-cols-3">
              <label className="min-w-[150px] font-bold text-default text-gray-700 sm:text-end">Từ ngày</label>

              <DatePicker
                id="tuNgay"
                className="col-span-2 sm:!ml-5 "
                // Trigger change when blur. e.g. datetime picker no need click confirm button
                changeOnBlur
                disabled={pickedDate !== 'Custom' && pickedDate !== ''}
                value={dataSearch.fromTime ? dayjs(dataSearch.fromTime) : undefined}
                format={'DD/MM/YYYY'}
                placeholder="dd/mm/yyyy"
                onChange={(date, dateString) => {
                  const pickDate = dateString !== '' ? dayjs(date).format('YYYY-MM-DD') : undefined;
                  setDataSearch({ ...dataSearch, fromTime: pickDate });
                }}
              />
            </div>
            {/* đến ngày */}
            <div className="w-full sm:flex-row  mb-1 sm:items-center grid grid-cols-3">
              <label className="min-w-[150px] font-bold text-default text-gray-700 sm:text-end">Đến ngày</label>

              <DatePicker
                id="denNgay"
                className="col-span-2 sm:!ml-5 "
                // Trigger change when blur. e.g. datetime picker no need click confirm button
                changeOnBlur
                disabled={pickedDate !== 'Custom' && pickedDate !== ''}
                value={dataSearch.toTime ? dayjs(dataSearch.toTime) : undefined}
                format={'DD/MM/YYYY'}
                placeholder="dd/mm/yyyy"
                onChange={(date, dateString) => {
                  const pickDate = dateString !== '' ? dayjs(date).format('YYYY-MM-DD') : undefined;
                  setDataSearch({ ...dataSearch, toTime: pickDate });
                }}
              />
            </div>

            {/* button tìm kiếm */}
            <div className="mt-2 mb-1 w-full flex justify-center col-span-2">
              <Button
                type="primary"
                loading={isLoading}
                onClick={handleSubmit(onSearch)}
                className="bg-primary !flex justify-between items-center gap-2 !px-3 !rounded-sm !py-1"
              >
                Chạy báo cáo
              </Button>
            </div>
          </form>
        </SearchCollapse>

        {/* BODY */}
        <div className="w-full bg-white p-3 rounded border border-neutral-300 mb-2 ">
          {/*=========== Pagination =======================*/}

          <CustomProTable<BC08>
            columns={columns}
            handleResize={handleResize}
            isResizablePresent={isResizablePresent}
            resizableColumnSelect={resizableColumnSelect}
            loading={isLoading}
            request={async (params = {}, sort, filter) => {
              setIsLoading(true);
              const data = await getDataAPI({
                ...dataSearch,
                paging: {
                  ...dataSearch.paging,
                  orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                  orderByDesc: Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                },
              });
              if (Object.values(sort).length) {
                setDataSearch({
                  ...dataSearch,
                  paging: {
                    ...dataSearch.paging,
                    orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                    orderByDesc: Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : '',
                  },
                });
              }
              setIsLoading(false);
              return {
                data: data,
                success: rootStore.reportStore.BC08Response.isSuccess,
              };
            }}
            dataSource={dataAPI.map((data) => data)}
            actionRef={tableRef} // Gán biến tham chiếu cho instance của bảng
            columnsState={{
              value: Object.keys(columnsState).length > 0 ? columnsState : {},
              onChange: (newColumnsState) => {
                handleColumnsStateChange(newColumnsState);
              },
            }}
            rowKey="stt"
            pagination={{
              pageSize: dataSearch.paging.pageSize,
              total: rootStore.reportStore.BC08Response.recordsTotal,
              current: dataSearch.paging.pageIndex,
              responsive: true,
              pageSizeOptions: [10, 25, 50, 100],
              showSizeChanger: true,
              position: ['topRight', 'bottomRight'],
              style: { margin: '10px 0' },
              showTotal: (total, range) => `Hiển thị ${range[0]}-${range[1]} của ${total} mục`,
              onChange: (page, pageSize) => {
                setDataSearch({
                  ...dataSearch,
                  paging: { ...dataSearch.paging, pageIndex: page, pageSize: pageSize },
                });
              },
            }}
            toolBarRender={() => [
              <Button
                size="middle"
                loading={isLoading}
                className="bg-primary !flex justify-between items-center gap-2 !px-3 !rounded-sm !py-1"
                onClick={async () => {
                  setIsLoading(true);
                  await rootStore.reportPresenter.exportExcelBC09({
                    ...dataSearch,
                  });
                  setIsLoading(false);
                }}
                type="primary"
              >
                <AiOutlineDownload className="block text-base" />
                <span className="block">Export Excel</span>
              </Button>,
              <SaveReportForm
                templateReportModalRef={templateReportModalRef}
                userReports={userReports}
                selectedReportId={selectedReportId}
              />,
            ]}
          />
        </div>

        <TemplateReportModal ref={templateReportModalRef} {...templateReportModalProps} />
      </div>
    ) : (
      <LoadingScreen />
    );
  });
}
